export default __webpack_public_path__ + "static/media/bh.4e7dcd4f.jpg";